import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import settings from './modules/settings'
import user from './modules/user'
import options from './modules/options'
import enumeration from './modules/enumeration'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    settings,
    user,
    options,
    enumeration
  },
  getters,
  mutations: {
    //set方法
    setDemoValue(state,demoValue){
      state.options = demoValue
    }
  }
})

export default store
